import { render, staticRenderFns } from "./ProductInsertModal.vue?vue&type=template&id=4884ac91&"
import script from "./ProductInsertModal.vue?vue&type=script&lang=js&"
export * from "./ProductInsertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports